// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__IwcHX","containerSearch":"styles_containerSearch__-5azI","header":"styles_header__Fsbtv"};